import ColorSelect from './colorSelect';

export default ColorSelect;
